import { apiClient } from '@/services/apiClient';
import type { PriceBreakdown } from '@/types/checkout';
import { useMutation } from '@tanstack/react-query';
import { Routes } from './routes';

interface CalculateEstimatedTaxResponse {
  isValid: boolean;
  priceBreakdown: PriceBreakdown;
  zipCode: string;
  state: string;
}

export const useCalculateTax = () => {
  return useMutation({
    mutationFn: async ({ address, zipCode }: { address: string; zipCode: string }) => {
      const results = await apiClient.get<CalculateEstimatedTaxResponse>(
        `${Routes.CALCULATE_TAX}?address=${address}&zipCode=${zipCode}`
      );
      return results;
    },
  });
};

export const useCalculateTaxByZipCode = () => {
  return useMutation({
    mutationFn: async ({ zipCode }: { zipCode: string }) => {
      const results = await apiClient.get<CalculateEstimatedTaxResponse>(`${Routes.CALCULATE_TAX}?zipCode=${zipCode}`);
      return results;
    },
  });
};
